import { router } from '@inertiajs/react';

import { cmsBillingPath } from '@/lib/routes';
import { useAiCreditStatus } from '@/stores/account-limits-store';
import { usePlanLimitModalStore } from '@/stores/plan-limit-modal-store';

const DEFAULT_MESSAGE =
  'Your AI credits are used up for now, but you can keep building your site as usual. ' +
  'Upgrade your plan or add more credits to keep using AI features without waiting.';

export function useAiCreditsExhausted(): boolean {
  const creditStatus = useAiCreditStatus();
  return creditStatus?.level === 'exhausted';
}

export function showAiCreditsExhaustedModal(message?: string): void {
  usePlanLimitModalStore.getState().showPlanLimitModal({
    title: "You're out of AI credits",
    description: message?.trim() || DEFAULT_MESSAGE,
    confirmLabel: 'Manage Credits',
    cancelLabel: 'Not now',
    onConfirm: () => router.visit(cmsBillingPath({ tab: 'ai-usage' })),
  });
}
